// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fba51d98","513":"ee31c502","703":"405e13d3"}[chunkId] + ".chunk.js";
};